import HikSetDriverCardModal from './hik-set-driver-card-modal.vue'
export default HikSetDriverCardModal
